const TEMPLATE = `
<section class="cases-section fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6">
                <p class="section-label" data-animate-child>Справжній медичний досвід</p>
            </div>
            <div class="col-lg-6 " style="margin-bottom: 24px !important;">
                <h2 data-animate-child data-delay="200">
                    Практика, що змінює лікування
                </h2>

                <p data-animate-child data-delay="600">
                    Ми ділимося випадками, де діагностика BML вплинула на вибір терапії та результат для пацієнта.
                    Це справжній досвід, підтверджений клінічною практикою.
                </p>

            </div>
        </div>

        <!-- Секція для блоків кейсів -->
        <div id="cases-section" class="cases-section-inner" data-section="cases-section">
            <!-- Тут будуть створюватися блоки кейсів через block system -->
        </div>
        <a class="load-more-" href="#">Завантажити більше</a>

    </div>
</section>
`;

class BmlCasesList extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-cases-list', BmlCasesList);
